export default __webpack_public_path__ + "static/lowfi-2d05eeaaefe28f966a1c6091943fa0d9.png";